import { computed, ref } from 'vue'
import { useKeycloak } from '@lib/keycloak'

export const useCurrentUser = () => {
    const error = ref(null)
    const keycloak = useKeycloak()

    const errorMessage = computed(() => {
        if (!error.value) {
            return null
        }
        return error.value.response?.data?.detail?.userMessage || error.value.response?.data?.userMessage || error.value.message || error.value
    })

    const corporationScopes = computed(() => {
        return keycloak.tokenParsed.corporationScopes
    })

    const uuidCorporations = computed(() => {
        return keycloak.tokenParsed.corporations
    })

    const userName = computed(() => {
        const keycloakUser = keycloak?.tokenParsed || {}
        const email = keycloakUser.email
        const userName = keycloakUser.preferred_username
        const name = keycloakUser.given_name && keycloakUser.family_name ? `${keycloakUser.given_name || ''} ${keycloakUser.family_name || ''}` : undefined

        return name || email || userName
    })

    const logout = () => {
        keycloak.logout()
    }

    const openUpdatePassword = async () => {
        if (error.value) {
            error.value = null
        }

        let url = await keycloak.createLoginUrl({
            action: 'UPDATE_PASSWORD'
        })
        .catch((err) => error.value = err)

        window.open(url, '_self')
    }

    return {
        uuidCorporations,
        corporationScopes,
        userName,
        openUpdatePassword,
        logout,
        errorMessage
    }
}

